export default "__VITE_ASSET__B6ntf$oB__"